module.exports = __webpack_public_path__ + "static/media/perro.f94e4083.svg";